/* eslint-disable */
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Flex } from "antd";
import userAvatar from "assets/icons/ic_account_circle.svg";
import noneBackgroundImg from 'assets/images/none_background.png';
import Loading from "components/atoms/Loading";
import { useToast } from "components/molecules/Toast";
import ChatBotFooter, {
  ChatbotFormReturnTypes,
  DEFAULT_FORMCHAT,
  QuestionConfirmType,
  RoleUserType,
  TextAreaInputChatBotTypes,
} from "components/organisms/ChatBotFooter";
import ChatMessage, {
  ChooseMessageTypes,
} from "components/organisms/ChatMessage";
import HeaderChatbot from "components/organisms/HeaderChatbot";
import CustomModal from "components/organisms/Modal";
import { ContextChatbot } from "components/templates/MainlayoutChatbot";
import useNetwork from "hooks/useNetwork";
import useWebSocket from "hooks/useWebSocket";
import ConversationHistory from "pages/ConversationHistory";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useInfiniteQuery, useMutation, useQuery } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  createConversationChatBotService,
  getConversationsChatBotService,
  refreshSessionChatBotService,
  saveResponseDiffService,
  sendMailOTPChatBotService,
  sendOTPChatBotService,
  verifyChatBotService,
  verifyOTPChatBotService,
  wsSendChatService
} from "services/accountConversations";
import {
  ChatMessageTypes,
  FeedBackEmojiType,
  KnowledgeUsagedTypes,
  ResponseTimePayload,
} from "services/accountConversations/types";
import { generateCustomerTokenService } from "services/auth";
import {
  addToLocalStorageSet,
  getLocalStorage,
  isInLocalStorageSet,
  setLocalStorage,
} from "services/common/storage";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { resetData, setCurrentConversaion, setCurrentUuid } from "store/socket";
import { setEnableWS } from "store/system";
import { Image, Typography } from "tfc-components";
import {
  AGENT_TYPE,
  AUTHENTICATION_TYPE,
  LOCAL_STORAGE_CHATBOT,
} from "utils/constants";
import mapModifiers, { getErrors, getTextFromHTML, scrollBottom } from "utils/functions";
import { v1 as uuidv1 } from "uuid";
import * as yup from 'yup';
import useLifetime from "./useLifetime";
import dayjs from "dayjs";
import { addDateHeaders } from "./helpers";

export type ConversationLinesTypes = {
  id: string;
  question: string;
  answer: string;
  code: string;
  isCopy?: boolean;
  isRemove?: boolean;
  feedbackEmoji?: FeedBackEmojiType;
  actions?: Array<ChooseMessageTypes>;
  hasActions?: boolean;
  files?: Array<UploadFileType>;
  error?: boolean;
  knowledgeUsaged?: Array<KnowledgeUsagedTypes>;
  buttons?: string[] | Array<{ action: string, name: string }>;
  action?: string;
  uuid?: string
  canRetry?: boolean;
  aiActionId?: number;
  exportChat?: {
    expiresAt: string;
    fileUrl: string;
  }[];
  timeResponse?: number;
  timeSendAt?: dayjs.Dayjs;
  createAt?: string;
  updateAt?: string;
  userSendAt?: string;
  attachedMedia?: {
    fileName: string;
    fileUrl: string;
    source: string;
  }[];
};

export type MessageChattingTypes = {
  code?: string;
  retryFromUuid?: string;
  message?: string;
  files?: Array<UploadFileType>;
  knowledgeUsaged?: Array<KnowledgeUsagedTypes>;
  action?: string;
  isRefresh?: boolean;
};

const DefaultValueMessage: MessageChattingTypes = {
  message: "",
  code: undefined,
  knowledgeUsaged: [],
};

interface ChattingProps {
  handleToggleExpand?: (isExpanded: boolean) => void;
  handleCloseChatbot?: () => void;
  chatbotEmbed?: boolean;
}
const convertDateToMS = (date: string) => new Date(date).getTime();
type TRef = React.MutableRefObject<ReturnType<typeof setTimeout> | null>;

const convertToMS = (time: number) => time * 60 * 1000;


const Chatting: React.FC<ChattingProps> = ({
  handleToggleExpand,
  handleCloseChatbot,
  chatbotEmbed,
}) => {

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const query = new URLSearchParams(window.location.search);
  const botId = query.get("botId") || (window as any).currentBotPath;
  const apiKey =
    searchParams.get("key") || getLocalStorage(LOCAL_STORAGE_CHATBOT.BOTKEY + botId);
  const codeConversation = searchParams.get("code") || "";
  const conversationTitle = searchParams.get("title") || "";
  const mode = searchParams.get("mode");
  const modeHistory = mode === "history";
  const role = getLocalStorage(LOCAL_STORAGE_CHATBOT.ROLE + botId);
  const socketData = useAppSelector((state) => state.socket.data);
  const dispatch = useAppDispatch();
  const isVerified =
    isInLocalStorageSet(LOCAL_STORAGE_CHATBOT.VERIFIED + botId, apiKey) &&
    (role === "staff" || role === "guest");

  /** State */
  const [isMinimize, setIsMinimize] = useState(false);
  const [isShowWarning, setIsShowWarning] = useState(false);
  const [conversations, setConversations] = useState<ConversationLinesTypes[]>(
    []
  );
  const [newQuestion, setNewQuestion] = useState<MessageChattingTypes & { userSendAt?: Date }>({
    message: "",
  });
  const newQuestionRef = useRef(newQuestion);
  const [answer, setAnswer] = useState<MessageChattingTypes>({ message: "" });
  const [displayAnwser, setDisplayAnswer] = useState<MessageChattingTypes>({
    message: "",
  });

  const [searchingData, setSearchingData] = useState(false);
  const [typing, setTyping] = useState(false);
  const [phoneVerify, setPhoneVerify] = useState<string>("");
  const [mailVerify, setMailVerify] = useState<string>("");
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [otpSendCounter, setOtpSendCounter] = useState(0);
  const [isPaused, setIsPaused] = useState<boolean>(false);
  const [curentAction, setCurentAction] = useState<string>('')
  const networkStatus = useNetwork();
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [triggerType, setTriggerType] = useState('')
  const [showActionButton, setShowActionButton] = useState(false)
  const [isAutoAction, setIsAutoAction] = useState<boolean>(false)
  const [sessionExpiredAt, setSessionExpiredAt] = useState<{ id: string, time: number }>({ id: '', time: 0 });
  const [firstLoad, setFirstLoad] = useState(true)
  const [showIdleWarning, setShowIdleWarning] = useState(false);
  const [showMaxlifeWarning, setShowMaxlifeWarning] = useState(false);
  const [isMaxLifetimeExpired, setIsMaxLifetimeExpired] = useState(false);
  const [currentPlayingCode, setCurrentPlayingCode] = useState<string | null>(null);

  useEffect(() => {
    if (!networkStatus.online) {
      if (!isInitialLoad) {
        showToast({
          message: "Lỗi mạng. Vui lòng kiểm tra kết nối và thử lại!",
          show: true,
          type: "error",
        });
      }
      setIsInitialLoad(false);
    } else if (!isInitialLoad) {
      showToast({
        message: "Đã khôi phục kết nối mạng!",
        show: true,
        type: "success",
      });
    }
  }, [networkStatus.online, isInitialLoad]);

  // function useDebuggableState(initialValue: any, name = 'state') {
  //   const [state, setState] = useState(initialValue);

  //   const debugSetState = React.useCallback((value: any) => {
  //     console.log(`[setState called on ${name}]`);
  //     console.trace(); // <== prints the call stack
  //     setState(value);
  //   }, []);

  //   return [state, debugSetState];
  // }

  /** Ref */
  const chattingBoxRef = useRef<HTMLDivElement>(null);
  const isCreateNewRef = useRef<boolean>(false);
  const firstScrollToBottom = useRef<boolean>(false);
  const qq = useRef(false);
  const questionConfirmTypeRef = useRef<QuestionConfirmType>("");
  const roleRef = useRef<RoleUserType | "guest" | "">("");
  const textAreaRef = useRef<TextAreaInputChatBotTypes>(null);
  const conversationAlreadyCreatedRef = useRef<boolean>(false);

  const { showToast } = useToast();
  const infoChatbot = useContext(ContextChatbot);

  useEffect(() => {
    if (modeHistory && isCreateNewRef.current) {
      isCreateNewRef.current = false;
    }
    firstScrollToBottom.current = false;
  }, [codeConversation, modeHistory]);

  /** React Hook Form */
  const getSchema = (type: string | undefined) => {
    const baseFields = {
      streamType: yup.string().optional(),
      files: yup.mixed().optional(),
    };

    switch (type) {
      case "questionNumber":
        return yup.object({
          ...baseFields,
          question: yup
            .string()
            .matches(/^\d+$/, "Only numeric characters are allowed")
            .required("Only numeric characters are allowed"),
        });

      case "questionEmail":
        return yup.object({
          ...baseFields,
          question: yup
            .string()
            .email("Invalid email format")
            .required("Invalid email format"),
        });

      default:
        return yup.object({
          ...baseFields,
          question: yup.string().optional(),
        });
    }
  };

  const method = useForm<ChatbotFormReturnTypes>({
    mode: "onSubmit",
    defaultValues: {
      question: "",
      streamType: "tokens",
      files: undefined,
    },
    resolver: yupResolver(getSchema(triggerType))
  });

  const renderMessage = (param: ConversationLinesTypes) => {
    setTyping(false);
    setAnswer({
      code: param.code,
      message: param.answer,
      knowledgeUsaged: param.knowledgeUsaged,
    });
    setConversations((prev) => [...prev, param]);
    setNewQuestion(DefaultValueMessage);
    setAnswer(DefaultValueMessage);
    scrollBottom(chattingBoxRef.current);
  };

  // Create conversation
  const { mutate: createConversation, mutateAsync: createConversationAsync, isLoading: isLoadingConversation } =
    useMutation(
      ["create-conversation"],
      (params: MessageChattingTypes) =>
        createConversationChatBotService({
          title: params.message || "",
        }),
      {
        onSuccess: (data, variables) => {
          dispatch(setCurrentConversaion({ data: data.code }));
          dispatch(setCurrentUuid({ data: data.code }));
          console.log("create conversation success", data);
          questionConfirmTypeRef.current = "canChat";
          isCreateNewRef.current = true;
          setSearchParams({
            ...Object.fromEntries(searchParams.entries()),
            code: data.code,
          });
          if (variables.isRefresh && (mode === "new" || mode === null && infoChatbot.welcomeMessage)) {
            const greetingMessage =
              infoChatbot.type === AGENT_TYPE.BOTH ||
                infoChatbot.type === AGENT_TYPE.VERIFIED
                ? infoChatbot?.welcomeMessage
                : infoChatbot.onboardMessage || infoChatbot.welcomeMessage;

            const codeFirstCoversation = uuidv1();
            setConversations([
              {
                id: codeFirstCoversation,
                code: codeFirstCoversation,
                question: "",
                answer: greetingMessage,
                files: [],
                hasActions: false,
                createAt: dayjs().toISOString(),
                userSendAt: dayjs().toISOString(),
              },
            ]);
            // setLocalStorage(LOCAL_STORAGE_CHATBOT.SESSION_DATA, JSON.stringify(infoChatbot.sessionData));
          }
        },
        onError: (err) => {
          showToast({
            message: getErrors(err),
            show: true,
            type: "error",
          });
        },
      },
    );

  useEffect(() => {
    if (
      !codeConversation &&
      !isCreateNewRef.current &&
      !isVerified &&
      infoChatbot.name
    ) {
      if (infoChatbot.type === AGENT_TYPE.ANONYMOUS) {
        conversationAlreadyCreatedRef.current = true;
        generateCustomerTokenMutate({ isRefresh: true });
        if (conversations.length === 0) {
          const codeFirstCoversation = uuidv1();
          setConversations([
            {
              id: codeFirstCoversation,
              code: codeFirstCoversation,
              question: "",
              answer: infoChatbot?.welcomeMessage || "",
              files: [],
              hasActions: false,
              createAt: dayjs().toISOString(),
              userSendAt: dayjs().toISOString(),
            },
          ]);
        }
      } else {
        const codeFirstCoversation = uuidv1();
        const greetingMessage =
          infoChatbot.type === AGENT_TYPE.BOTH ||
            infoChatbot.type === AGENT_TYPE.VERIFIED
            ? infoChatbot?.onboardMessage
            : "";
        setShowSuggestion(true);
        setConversations([
          {
            id: codeFirstCoversation,
            code: codeFirstCoversation,
            question: "",
            answer: greetingMessage,
            isCopy: false,
            isRemove: false,
            files: [],
            hasActions: false,
            createAt: dayjs().toISOString(),
            userSendAt: dayjs().toISOString(),
          },
        ]);
      }
    } else if (codeConversation && !isCreateNewRef.current) {
      questionConfirmTypeRef.current = "canChat";
    }
  }, [infoChatbot]);

  const onChooseMessage = (ms: ChooseMessageTypes) => {
    if (ms.type === "whoAreU") {
      setShowSuggestion(false);
      questionConfirmTypeRef.current = "";
      const verifyMessage = (() => {
        switch (infoChatbot.verifyType) {
          case AUTHENTICATION_TYPE.SMS_OTP: {
            return "Vui lòng nhập số điện thoại của bạn để xác thực.";
          }
          case AUTHENTICATION_TYPE.EMAIL_OTP: {
            return "Vui lòng nhập email của bạn để xác thực.";
          }
          default: {
            return "Vui lòng nhập số điện thoại của bạn để xác thực.";
          }
        }
      })();
      const answerWhoAreU = {
        id: "answerWhoAreU",
        code: "",
        question: ms.text,
        answer:
          ms.value === "staff" ? verifyMessage : infoChatbot?.welcomeMessage,
        isCopy: false,
        isRemove: false,
        hasActions: false,
      } as ConversationLinesTypes;
      if (ms.value === "staff") {
        const questionType = (() => {
          switch (infoChatbot.verifyType) {
            case AUTHENTICATION_TYPE.SMS_OTP: {
              return "enterPhone";
            }
            case AUTHENTICATION_TYPE.EMAIL_OTP: {
              return "enterMail";
            }
            default: {
              return "enterPhone";
            }
          }
        })();
        roleRef.current = "staff";
        questionConfirmTypeRef.current = questionType;
        setNewQuestion({
          message: "Nhân viên công ty",
        });
        setTyping(true);
        scrollBottom(chattingBoxRef.current);
        renderMessage(answerWhoAreU);
      } else {
        roleRef.current = "guest";
        questionConfirmTypeRef.current = "canChat";
        generateCustomerTokenMutate({});
        setNewQuestion({
          message: "Khách hàng",
        });
        setTyping(true);
        scrollBottom(chattingBoxRef.current);
        renderMessage(answerWhoAreU);
      }
    } else if (ms.type === "resendOtp" && phoneVerify) {
      setOtpSendCounter(0);
      setNewQuestion({
        message: "Gửi lại OTP",
      });
      sendOTPChatBot({
        phone: phoneVerify,
        question: "Gửi lại OTP",
        isResend: true,
      });
      setTyping(true);
      scrollBottom(chattingBoxRef.current);
    } else if (ms.type === "resendOtp" && mailVerify) {
      setOtpSendCounter(0);
      setNewQuestion({
        message: "Gửi lại OTP",
      });
      sendMailOTPChatBot({
        mail: mailVerify,
        question: "Gửi lại OTP",
        isResend: true,
      });
      setTyping(true);
      scrollBottom(chattingBoxRef.current);
    }
  };

  const queryKey = ["get-conversations-items", codeConversation];

  /** React Query */
  const { mutate: sendMessageMutate } = useMutation({
    mutationKey: ["send-message"],
    mutationFn: (params: ChatMessageTypes) =>
      wsSendChatService(codeConversation, params),
    onError: (errors: Error | ErrorResponse[]) => {
      setTyping(false);
      setSearchingData(false);
      const codeAnswerError = uuidv1();
      const errorMess = {
        answer: "Đã có lỗi xảy ra. Vui lòng thử lại!",
        code: codeAnswerError,
        id: codeAnswerError,
        question: newQuestion.message,
        hasActions: false,
        files: newQuestion.files,
        error: true,
      } as ConversationLinesTypes;

      renderMessage(errorMess);
      setAnswer(DefaultValueMessage);
      // setNewQuestion(DefaultValueMessage);
      scrollBottom(chattingBoxRef.current);
      console.log("errors", errors);
    },
  });

  const { mutate: generateCustomerTokenMutate } = useMutation({
    mutationKey: ["generate-customer-token"],
    mutationFn: ({ isRefresh }: any) => generateCustomerTokenService(),
    onSuccess: (data, variables) => {
      if (data.accessToken && data.refreshToken) {
        setLocalStorage(
          LOCAL_STORAGE_CHATBOT.ACCESSTOKEN_CHATBOT + botId,
          data.accessToken
        );

        setLocalStorage(
          LOCAL_STORAGE_CHATBOT.REFRESHTOKEN_CHATBOT,
          data.refreshToken
        );
        setLocalStorage(LOCAL_STORAGE_CHATBOT.ROLE + botId, "guest");
        addToLocalStorageSet(LOCAL_STORAGE_CHATBOT.VERIFIED + botId, apiKey);
        dispatch(setEnableWS(data.accessToken));
        createConversation({ isRefresh: variables?.isRefresh });
        setSessionExpiredAt({ id: uuidv1(), time: convertDateToMS(data.expiresAt) - Date.now() });
        // setLocalStorage(LOCAL_STORAGE_CHATBOT.MAXLIFE_SESSION, data.expiresAt);
      }
    },
    onError: (err) => {
      showToast({
        message: getErrors(err),
        show: true,
        type: "error",
      });
    },
  });

  const { mutate: saveResponseDiffMutate } = useMutation({
    mutationKey: ["save-response-diff"],
    mutationFn: (params: ResponseTimePayload) => saveResponseDiffService(params),
  })

  const {
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    data: dataConversationItem,
  } = useInfiniteQuery(
    queryKey,
    ({ pageParam = 1 }) => {
      if (codeConversation)
        return getConversationsChatBotService(codeConversation, {
          page: pageParam,
          limit: 15,
        });
    },

    {
      getNextPageParam: (lastPage) => {
        if (lastPage && lastPage.meta)
          lastPage.meta.page < lastPage.meta.totalPages
            ? lastPage.meta.page + 1
            : false;
      },
      onSuccess(data) {
        dispatch(setCurrentConversaion({ data: codeConversation }));
        textAreaRef.current?.hideSuggestionMsg();
        if (data.pages.length > 0) {
          const combineData = data.pages.reduce((acc, cur) => {
            // eslint-disable-next-line no-param-reassign\
            if (cur)
              acc = [
                ...cur.data
                  .map(
                    (item) =>
                    ({
                      id: item.code,
                      question: item.question === " " ? "" : item.question,
                      answer: item.answer || "",
                      code: item.code,
                      feedbackEmoji: item.feedbackEmoji,
                      knowledgeUsaged: item.knowledgeUsaged,
                      attachedMedia: item.attachedMedia,
                      files: item.files.map((f) => ({
                        id: f.code,
                        fileView: {
                          name: f.name,
                          type: f.extension,
                          code: f.code,
                          path: f.path,
                          size: f.size,
                        },
                      })),
                      buttons: item?.buttons,
                      uuid: item?.uuid,
                      canRetry: item?.aiActionId ? false : true,
                      exportChat: item?.exportChat,
                      createAt: item.createdAt,
                      updateAt: item.updatedAt,
                      timeSendAt: dayjs(item.updatedAt),
                      timeResponse: item.ttlResTime,
                      userSendAt: (item.createdAt)
                    } as ConversationLinesTypes)
                  )
                  .reverse(),
                ...acc,
              ];
            return acc;
          }, [] as ConversationLinesTypes[]);
          setConversations(combineData);
        }
      },
      onError: (err) => {
        getErrors(err);
      },
      onSettled: () => {
        if (firstScrollToBottom.current === false) {
          firstScrollToBottom.current = true;
          setTimeout(() => {
            const element = chattingBoxRef.current;
            if (element) {
              chattingBoxRef.current.scroll({ top: element.scrollHeight });
            }
          }, 150);
        }

        // if (codeConversation) {
        const codeFirstCoversation = uuidv1();
        setConversations((prev) => [
          {
            id: codeFirstCoversation,
            code: codeFirstCoversation,
            question: "",
            answer: infoChatbot.welcomeMessage,
            files: [],
            hasActions: false,
            createAt: prev[0]?.createAt,
          },
          ...prev,
        ]);
      },
      // }
      enabled:
        !!codeConversation && !isCreateNewRef.current && role === "staff",
    }
  );

  useEffect(() => {
    newQuestionRef.current = newQuestion;
  }, [newQuestion]);
  // Handle websocket
  useEffect(() => {
    if (!socketData.length) {
      return;
    }
    const last = socketData[socketData.length - 1];
    const prev = socketData[socketData.length - 2];
    if (last?.payload) {
      // Response time chat bot
      let timeResponse = (dayjs().diff(newQuestion.userSendAt || new Date()));
      if (last.payload?.metadata?.endAiAction) {
        timeResponse = dayjs().diff(conversations[conversations.length - 1]?.timeSendAt);
      }
      const timeSendAt = (dayjs(new Date()));
      const userSendAt = (dayjs(newQuestion.userSendAt || new Date()));
      switch (last.type) {
        case "answerTokens":
          if (!isPaused) {
            setTyping(true);
          }
          setSearchingData(false);
          setAnswer((prev) => ({
            ...prev,
            code: last.payload.metadata.code,
            message: String(prev.message) + last.payload.tokens,
            timeResponse,
            timeSendAt,
            userSendAt: dayjs(userSendAt).toISOString()
          }));
          // imageFirstTokenFlag = false;
          scrollBottom(chattingBoxRef.current);
          break;

        case "fallback":
        case "finish":
          setTyping(false);
          setSearchingData(false)
          if (!isPaused) {
            setConversations((prev) => [
              ...prev,
              {
                id: last.payload.metadata.uuid,
                question: newQuestion.message || "",
                answer: last.payload.answer,
                code: last.payload.metadata.code,
                files: newQuestion.files,
                canRetry: !last?.payload?.metadata?.endAiAction && !last?.payload?.metadata?.action,
                exportChat: last?.payload?.exportChat,
                timeResponse,
                timeSendAt,
                userSendAt: dayjs(userSendAt).toISOString()
              },
            ]);
            setIsPaused(false);
          } else {
            setConversations((prev) => [
              ...prev,
              {
                id: last.payload.metadata.uuid,
                question: newQuestion.message || "",
                answer: String(displayAnwser.message),
                code: last.payload.metadata.code,
                files: newQuestion.files,
                knowledgeUsaged: displayAnwser.knowledgeUsaged,
                attachedMedia: last.payload?.attachedMedia,
                canRetry: !last?.payload?.metadata?.endAiAction && !last?.payload?.metadata?.action,
                exportChat: last?.payload?.exportChat,
                timeResponse,
                timeSendAt,
                userSendAt: dayjs(userSendAt).toISOString()
              },
            ]);
            setDisplayAnswer(DefaultValueMessage);
          }
          setNewQuestion(DefaultValueMessage);
          scrollBottom(chattingBoxRef.current);
          saveResponseDiffMutate({ ttlResTime: timeResponse, codeConversation: codeConversation, code: last.payload.metadata.uuid || '' });
          break;

        case "aiAction":
          const currentQuestion = newQuestionRef.current;
          // reset ngay lập tức
          setNewQuestion(DefaultValueMessage);

          setCurentAction(last?.payload?.metadata?.action || "");
          setTriggerType(last?.payload?.triggerType || "");

          if (last?.payload?.buttons && last?.payload?.buttons?.length > 0) {
            setShowActionButton(true);
          }

          const knowledgeUsaged =
            last?.payload?.triggerType === "messageImage"
              ? last?.payload?.knowledgeUsaged?.map((image) => ({
                source: "upload",
                fileName: image?.fileName?.name,
                fileUrl: image?.fileName?.url,
              }))
              : last?.payload?.knowledgeUsaged;

          const conversationItem = {
            id: last.payload.metadata.uuid,
            question: currentQuestion.message || "",
            answer: last.payload.answer,
            code: last.payload.metadata.code,
            knowledgeUsaged,
            attachedMedia: last.payload?.attachedMedia,
            buttons: last?.payload?.buttons,
            action: last?.payload?.metadata?.action,
            canRetry:
              !last?.payload?.metadata?.endAiAction &&
              !last?.payload?.metadata?.action,
            exportChat: last?.payload?.exportChat,
            files: currentQuestion.files || [],
            timeResponse,
            timeSendAt,
            userSendAt: dayjs(userSendAt).toISOString()
          };
          newQuestionRef.current.message = ""

          setTyping(false);
          setSearchingData(false);
          setConversations((prev) => [...prev, conversationItem]);
          setIsPaused(false);
          scrollBottom(chattingBoxRef.current);
          saveResponseDiffMutate({ ttlResTime: timeResponse, codeConversation: codeConversation, code: last.payload.metadata.uuid || '' });
          break;

        case "turnOffAiAuto":
          if (last?.payload?.metadata?.action) {
            setCurentAction(last?.payload?.metadata?.action)
          }
          else {
            setCurentAction('')
          }

          if (last.payload?.triggerType) {
            setTriggerType(last.payload?.triggerType)
          } else {
            setTriggerType('')
          }

          if (last?.payload?.buttons && last?.payload?.buttons?.length > 0) {
            setShowActionButton(true)
          }
          setTyping(false);
          setSearchingData(false);
          setConversations((prev) => [
            ...prev,
            {
              id: last.payload.metadata.uuid,
              question: newQuestion.message || "",
              answer: last.payload.answer,
              code: last.payload.metadata.code,
              knowledgeUsaged:
                last?.payload?.triggerType === "messageImage"
                  ? last?.payload?.knowledgeUsaged?.map((image) => ({ source: 'upload', fileName: image?.fileName?.name, fileUrl: image?.fileName?.url }))
                  : last?.payload?.knowledgeUsaged,
              attachedMedia: last.payload?.attachedMedia,
              buttons: last?.payload?.buttons,
              action: last?.payload?.metadata?.action,
              canRetry: !last?.payload?.metadata?.endAiAction && !last?.payload?.metadata?.action,
              exportChat: last?.payload?.exportChat,
              timeResponse,
              timeSendAt,
              userSendAt: dayjs(userSendAt).toISOString()
            },
          ]);
          setIsPaused(false);
          setNewQuestion(DefaultValueMessage);
          scrollBottom(chattingBoxRef.current);
          saveResponseDiffMutate({ ttlResTime: timeResponse, codeConversation: codeConversation, code: last.payload.metadata.uuid || '' });
          break;

        case "multiAutoAiAction":
          setIsAutoAction(true)
          if (last?.payload?.metadata?.action) {
            setCurentAction(last?.payload?.metadata?.action)
          }
          else {
            setCurentAction('')
          }

          if (last.payload?.triggerType) {
            setTriggerType(last.payload?.triggerType)
          } else {
            setTriggerType('')
          }

          if (last?.payload?.buttons && last?.payload?.buttons?.length > 0) {
            setShowActionButton(true)
          }
          setTyping(false);
          setSearchingData(false);
          setConversations((prev) => [
            ...prev,
            {
              id: last.payload.metadata.uuid,
              question: newQuestion.message || "",
              answer: last.payload.answer,
              code: last.payload.metadata.code,
              knowledgeUsaged:
                last?.payload?.triggerType === "messageImage"
                  ? last?.payload?.knowledgeUsaged?.map((image) => ({ source: 'upload', fileName: image?.fileName?.name, fileUrl: image?.fileName?.url }))
                  : last?.payload?.knowledgeUsaged,
              attachedMedia: last.payload?.attachedMedia,
              buttons: last?.payload?.buttons,
              action: last?.payload?.metadata?.action,
              canRetry: !last?.payload?.metadata?.endAiAction && !last?.payload?.metadata?.action,
              exportChat: last?.payload?.exportChat,
              timeResponse,
              timeSendAt,
              userSendAt: dayjs(userSendAt).toISOString()
            },
          ]);
          setIsPaused(false);
          setNewQuestion(DefaultValueMessage);
          scrollBottom(chattingBoxRef.current);
          saveResponseDiffMutate({ ttlResTime: timeResponse, codeConversation: codeConversation, code: last.payload.metadata.uuid || '' });

          break;

        case "file":
          {
            console.log({ file: last.payload });
            // setAnswer((prev) => ({
            //   ...prev,
            //   message: prev.message + data.tokens,
            // }));
            // message += data.tokens;
            // imageFirstTokenFlag = false;
            scrollBottom(chattingBoxRef.current);
          }
          break;

        case "image":
          {
            console.log({ image: last.payload });
            // setAnswer((prev) => ({
            //   ...prev,
            //   message: prev.message + data.tokens,
            // }));
            // message += data.tokens;
            // fileFirstTokenFlag = false;
            scrollBottom(chattingBoxRef.current);
          }
          break;

        case "knowledgeUsaged":
          setAnswer((prev) => ({
            ...prev,
            knowledgeUsaged: [
              ...(prev.knowledgeUsaged || []),
              ...(last.payload?.items || []),
            ],
          }));
          break;

        default:
          break;
      }
    }
  }, [socketData]);

  useEffect(() => {
    if (answer.knowledgeUsaged?.length && !isPaused) {
      setConversations((prev) => {
        const newConversations = [...prev];
        newConversations[newConversations.length - 1] = {
          ...newConversations[newConversations.length - 1],
          knowledgeUsaged: answer.knowledgeUsaged,
        };
        return newConversations;
      });
      setAnswer(DefaultValueMessage);
    }
  }, [answer, isPaused]);

  useEffect(() => {
    if (isVerified) {
      const token = getLocalStorage(LOCAL_STORAGE_CHATBOT.ACCESSTOKEN_CHATBOT + botId);
      if (token) {
        dispatch(setEnableWS(token));
      }
    }
  }, [isVerified]);
  const url = new URL(window.location.href);
  const domain = url.searchParams.get("domain");
  const token = url.searchParams.get("token");

  const { mutate: refreshSessionChatbot } = useMutation(['refreshSessionChatbot'], (params: { isRefresh?: boolean }) => refreshSessionChatBotService(), {
    onSuccess: async (data, variables) => {
      if (botId) {
        setLocalStorage(LOCAL_STORAGE_CHATBOT.ACCESSTOKEN_CHATBOT + botId, data.accessToken);
        setLocalStorage(LOCAL_STORAGE_CHATBOT.REFRESHTOKEN_CHATBOT + botId, data.refreshToken);
        setSessionExpiredAt({ id: uuidv1(), time: convertDateToMS(data.expiresAt) - Date.now() });
        if (variables.isRefresh) {
          await createConversationAsync({ isRefresh: true });
          await infoChatbot.getInfoChatBotAsync()
        }
      }
    }
  });

  // // Verify chatbot
  const verifyQuery = useQuery(["verify-chat-bot", apiKey], () => verifyChatBotService({ integrateUrl: domain || window.location.origin, integrateCode: token || "" }), {
    onSuccess: (data) => {
      if (data.accessToken && data.refreshToken) {
        roleRef.current = "staff";
        setLocalStorage(
          LOCAL_STORAGE_CHATBOT.ACCESSTOKEN_CHATBOT + botId,
          data.accessToken
        );
        setLocalStorage(
          LOCAL_STORAGE_CHATBOT.REFRESHTOKEN_CHATBOT + botId,
          data.refreshToken
        );
        if (!infoChatbot?.avatar) {
          infoChatbot.getInfoChatBot();
        }
      }
    },
    onError: (err) => {
      showToast({
        message: getErrors(err),
        show: true,
        type: "error",
      });
    },
    enabled: !isVerified && !!apiKey && !codeConversation && !modeHistory,
  });

  // Verify OTP
  const { mutate: verifyOTPChatBot, isLoading: isLoadingverifyOTPChatbot } =
    useMutation(
      ["send-otp-chat-bot", apiKey],
      (params: { phone?: string; mail?: string; otp: string }) =>
        verifyOTPChatBotService(params),
      {
        onSuccess: (data, variables) => {
          const c = {
            answer: `Xác thực thành công! Bây giờ bạn có thể sử dụng đầy đủ các tính năng của ${infoChatbot?.name || ""
              }. Bắt đầu khám phá ngay! 🚀`,
            code: "",
            id: "",
            question: variables.otp,
            hasActions: false,
          } as ConversationLinesTypes;
          if (data.accessToken && data.refreshToken) {
            questionConfirmTypeRef.current = "";
            renderMessage(c);
            setLocalStorage(
              LOCAL_STORAGE_CHATBOT.ACCESSTOKEN_CHATBOT + botId,
              data.accessToken
            );
            setLocalStorage(
              LOCAL_STORAGE_CHATBOT.REFRESHTOKEN_CHATBOT + botId,
              data.refreshToken
            );
            setLocalStorage(LOCAL_STORAGE_CHATBOT.ROLE + botId, "staff");
            createConversation({});
            conversationAlreadyCreatedRef.current = true;
            addToLocalStorageSet(LOCAL_STORAGE_CHATBOT.VERIFIED + botId, apiKey);
            setPhoneVerify("");
            setMailVerify("");
            textAreaRef.current?.showSuggestionMsg();
            setSessionExpiredAt({ id: uuidv1(), time: convertDateToMS(data.expiresAt) - Date.now() });
            dispatch(setEnableWS(data.accessToken));
          }
        },
        onError: (err, variables) => {
          const generalError = {
            code: "",
            id: "",
            question: variables.otp,
            hasActions: false,
            error: true,
            answer: "Đã có lỗi xảy ra vui lòng thử lại!",
          } as ConversationLinesTypes;
          if (err && Array.isArray(err)) {
            setOtpSendCounter((prev) => prev + 1);
            const c = {
              code: "",
              id: "",
              question: variables.otp,
              hasActions: false,
            } as ConversationLinesTypes;
            err.forEach((item: ErrorAPIResponseTypes) => {
              if (item.code === "invalid") {
                // TODO
                c.answer = `❌ Mã OTP không chính xác
                ${otpSendCounter < 2
                    ? `Vui lòng kiểm tra lại và nhập chính xác mã OTP.
                  Bạn có thể gửi lại mã hoặc yêu cầu gửi lại OTP.`
                    : "Vui lòng chọn yêu cầu gửi lại mã OTP để tiếp tục xác thực."
                  }`;
                renderMessage(c);
              } else if (item.code === "maxOtpDay") {
                c.answer = `❌ Bạn đã vượt quá số lần yêu cầu mã OTP trong ngày
                Vui lòng thử lại vào ngày mai để tiếp tục xác minh`;
                renderMessage(c);
              } else if (item.code === "expireAt") {
                c.answer = `❌ Mã OTP đã hết hạn
                Vui lòng chọn yêu cầu gửi lại mã OTP để tiếp tục xác thực`;
                renderMessage(c);
              } else {
                renderMessage(generalError);
              }
            });
          } else {
            renderMessage(generalError);
          }
        },
        // enabled: !!apiKey,
      }
    );

  const { mutate: sendOTPChatBot, isLoading: isLoadingSendOTPChatbot } =
    useMutation(
      ["send-otp-chat-bot", apiKey],
      (params: { phone: string; question?: string; isResend?: boolean }) =>
        sendOTPChatBotService(params),
      {
        onSuccess: (data, variables) => {
          setPhoneVerify(variables.phone);
          console.log("sendOTPChatBot", data);
          questionConfirmTypeRef.current = "verifyByOTP";
          const c = {
            answer: `Chúng tôi đã gửi ${variables.isResend ? "lại " : ""
              }mã OTP đến số điện thoại <strong>${variables.phone
              }</strong>. Vui lòng nhập mã OTP để hoàn tất quá trình xác thực.`,
            code: "",
            id: "",
            question: variables?.isResend
              ? variables.question
              : variables.phone,
            hasActions: false,
          } as ConversationLinesTypes;
          setAnswer({
            message: c.answer,
          });
          renderMessage(c);
        },
        onError: (err, variables) => {
          if (err && Array.isArray(err)) {
            const c = {
              code: "",
              id: "",
              question: variables.phone,
              hasActions: false,
            } as ConversationLinesTypes;
            err.forEach((item: ErrorAPIResponseTypes) => {
              if (item.code === "invalid") {
                c.answer = `❌ Số điện thoại bạn nhập chưa được đăng ký trên hệ thống.
              Vui lòng kiểm tra lại và nhập số điện thoại chính xác.`;
                renderMessage(c);
              }
              if (item.code === "digitsBetween") {
                c.answer = `❌ Số điện thoại bạn nhập không đúng định dạng.
                Vui lòng nhập lại với đúng định dạng gồm 10 chữ số, không chứa ký tự đặc biệt, khoảng trắng hoặc chữ cái`;
                renderMessage(c);
              }
              if (item.code === "maxOtpDay") {
                c.answer = `❌ Bạn đã vượt quá số lần yêu cầu mã OTP trong ngày
                Vui lòng thử lại vào ngày mai để tiếp tục xác minh`;
                renderMessage(c);
              }
            });
            return;
          }
          const c = {
            code: "",
            id: "",
            question: variables.phone,
            hasActions: false,
            error: true,
          } as ConversationLinesTypes;
          c.answer =
            "Đã có lỗi xảy ra vui lòng nhập số lại số điện thoại để thử lại!";
          renderMessage(c);
        },
        onMutate: () => {
          setTyping(false);
        },
        // enabled: !!apiKey,
      }
    );

  const { mutate: sendMailOTPChatBot, isLoading: isLoadingSendMailOTPChatbot } =
    useMutation(
      ["send-otp-chat-bot", apiKey],
      (params: { mail: string; question?: string; isResend?: boolean }) =>
        sendMailOTPChatBotService(params),
      {
        onSuccess: (data, variables) => {
          setMailVerify(variables.mail);
          questionConfirmTypeRef.current = "verifyByOTP";
          const c = {
            answer: `Chúng tôi đã gửi ${variables.isResend ? "lại " : ""
              }mã OTP đến email <strong>${variables.mail
              }</strong>. Vui lòng nhập mã OTP để hoàn tất quá trình xác thực.`,
            code: "",
            id: "",
            question: variables?.isResend ? variables.question : variables.mail,
            hasActions: false,
          } as ConversationLinesTypes;
          setAnswer({
            message: c.answer,
          });
          renderMessage(c);
        },
        onError: (err, variables) => {
          if (err && Array.isArray(err)) {
            const c = {
              code: "",
              id: "",
              question: variables.mail,
              hasActions: false,
            } as ConversationLinesTypes;
            err.forEach((item: ErrorAPIResponseTypes) => {
              if (item.code === "invalid") {
                c.answer = `❌ Email bạn nhập chưa được đăng ký trên hệ thống.
                Vui lòng kiểm tra lại và nhập email chính xác.`;
                renderMessage(c);
              }
              if (item.code === "email") {
                c.answer = `❌ Email bạn nhập không đúng định dạng.
                Vui lòng nhập lại với đúng định không chứa ký tự đặc biệt hoặc khoảng trắng`;
                renderMessage(c);
              }
              if (item.code === "maxOtpDay") {
                c.answer = `❌ Bạn đã vượt quá số lần yêu cầu mã OTP trong ngày
                Vui lòng thử lại vào ngày mai để tiếp tục xác minh`;
                renderMessage(c);
              }
            });
            return;
          }
          const c = {
            code: "",
            id: "",
            question: variables.mail,
            hasActions: false,
            error: true,
          } as ConversationLinesTypes;
          c.answer =
            "Đã có lỗi xảy ra vui lòng nhập số lại số điện thoại để thử lại!";
          renderMessage(c);
        },
        onMutate: () => {
          setTyping(false);
        },
        // enabled: !!apiKey,
      }
    );
  const onSubmit = (
    data: MessageChattingTypes,
    oldData?: ConversationLinesTypes[]
  ) => {
    const uuid = uuidv1();
    setNewQuestion({ ...data, userSendAt: new Date() });
    method.reset(DEFAULT_FORMCHAT);
    if (textAreaRef.current) {
      textAreaRef.current?.resetStyleInput();
    }
    if (data.code) {
      dispatch(setCurrentUuid({ data: data.code }));
    }
    // streamAnswer(data, oldData);
    const toSendData = {
      question: data.message,
      uuid: data.code || uuid,
      retryFromUuid: data.retryFromUuid,
      streamType: "jsonline",
      files: data.files?.map((item) => ({
        ...item.fileSubmit,
      })),
      action: data.action || curentAction,
    } as ChatMessageTypes;
    if (data.message?.toLocaleLowerCase() === 'x' && isAutoAction) {
      toSendData.turnOffAiAuto = true
      setShowActionButton(false)
    }
    // Reset Anwser when in case user already stop message
    setIsPaused(false);
    setAnswer(DefaultValueMessage);
    setDisplayAnswer(DefaultValueMessage);
    sendMessageMutate(toSendData);
    setSearchingData(true);
    scrollBottom(chattingBoxRef.current);
    dispatch(resetData());
    setTriggerType('')
  };

  const onSubmitPhone = (data: { question: string }) => {
    if (data.question) {
      setTyping(true);
      sendOTPChatBot({
        phone: data.question,
      });
      method.reset(DEFAULT_FORMCHAT);
      if (textAreaRef.current) {
        textAreaRef.current?.resetStyleInput();
      }
      scrollBottom(chattingBoxRef.current);
    }
  };

  const onSubmitMail = (data: { question: string }) => {
    if (data.question) {
      setTyping(true);
      sendMailOTPChatBot({
        mail: data.question,
      });
      method.reset(DEFAULT_FORMCHAT);
      if (textAreaRef.current) {
        textAreaRef.current?.resetStyleInput();
      }
      scrollBottom(chattingBoxRef.current);
    }
  };

  const onSubmitVerifyOTP = (data: { question: string }) => {
    if (data.question && data.question !== "Gửi lại OTP" && phoneVerify) {
      setTyping(true);
      verifyOTPChatBot({
        otp: data.question,
        phone: phoneVerify,
      });
      method.reset(DEFAULT_FORMCHAT);
      if (textAreaRef.current) {
        textAreaRef.current?.resetStyleInput();
      }
    } else if (data.question && data.question !== "Gửi lại OTP" && mailVerify) {
      setTyping(true);
      verifyOTPChatBot({
        otp: data.question,
        mail: mailVerify,
      });
      method.reset(DEFAULT_FORMCHAT);
      if (textAreaRef.current) {
        textAreaRef.current?.resetStyleInput();
      }
    }
    scrollBottom(chattingBoxRef.current);
  };

  const handleScroll = (scrollTop: number) => {
    const currenPage =
      dataConversationItem?.pageParams &&
        dataConversationItem?.pageParams.length > 0
        ? ((dataConversationItem?.pageParams[
          dataConversationItem?.pageParams.length - 1
        ] || 1) as number)
        : 1;
    if (scrollTop < 120 * currenPage && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  };

  const onHandleRetryAnswer = (reTryQuestion: MessageChattingTypes) => {
    if (reTryQuestion.code) {
      const oldData = [...conversations];
      const indexRemoveItem = conversations.findIndex(
        (item) => item.code === reTryQuestion.code
      );
      const newConversation = [...conversations];
      const containItems = newConversation.slice(0, indexRemoveItem);
      setConversations(containItems);

      const newQuestion: MessageChattingTypes = {
        code: uuidv1(),
        retryFromUuid: reTryQuestion.code,
        message: reTryQuestion.message,
        files: reTryQuestion.files,
        action: reTryQuestion.action,
      };
      onSubmit(newQuestion, oldData);
    }
  };

  const onHandleDeleteQAndA = (code?: string) => {
    const qaFilter = conversations.filter((item) => item.code !== code);
    setConversations(qaFilter);
  };

  useEffect(() => {
    if (apiKey && botId) {
      setLocalStorage(LOCAL_STORAGE_CHATBOT.BOTKEY + botId, apiKey);
      (window as any).currentBotPath = botId;
    }
  }, [apiKey, botId]);
  useEffect(() => {
    if (
      (isVerified &&
        !modeHistory &&
        !codeConversation &&
        !conversationAlreadyCreatedRef.current &&
        infoChatbot.name) ||
      mode === "new"
    )
      createConversation({ isRefresh: true });
  }, [isVerified, modeHistory, infoChatbot]);

  if (!apiKey) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography.Text>ChatBot chưa được khởi tạo!</Typography.Text>
      </div>
    );
  }

  useEffect(() => {
    if (isPaused) {
      return;
    } else setDisplayAnswer(answer);
  }, [answer, isPaused]);

  useEffect(() => {
    if (!isVerified && firstLoad) {
      setFirstLoad(false)
      verifyQuery.refetch().then(() => {
        setSearchParams({ key: getLocalStorage(LOCAL_STORAGE_CHATBOT.BOTKEY + botId) || '' })
        useWebSocket()
      }
      )
    }
  }, [isVerified]);

  // const idleMs = 30000;
  const idleMs = useMemo(
    () => convertToMS(infoChatbot?.sessionData?.idleTime ?? 2),
    [infoChatbot?.sessionData?.idleTime],
  );

  // const idleWarnBeforeMs = 20000;
  const idleWarnBeforeMs = useMemo(
    () => idleMs - convertToMS(infoChatbot?.sessionData?.notifyExpiryIdleTime ?? 1),
    [infoChatbot?.sessionData?.notifyExpiryIdleTime],
  );

  useEffect(
    () => setSessionExpiredAt({ id: uuidv1(), time: convertDateToMS(infoChatbot?.sessionData?.expiresAt || '') - Date.now() }),
    [infoChatbot?.sessionData?.expiresAt],
  );

  const lifetimeWarnBeforeMs = useMemo(
    () => convertToMS(infoChatbot?.sessionData?.notifyExpiryMaxLifeTime ?? 2),
    [infoChatbot?.sessionData?.notifyExpiryMaxLifeTime],
  );

  const handleSessionContinue = () => {
    refreshSessionChatbot({
      isRefresh: false
    });
    setShowMaxlifeWarning(false);
    setShowIdleWarning(false);
  };

  const handleMaxLifeReset = () => {
    setShowMaxlifeWarning(false);
    setIsMaxLifetimeExpired(false);
    setShowIdleWarning(false);
    refreshSessionChatbot({
      isRefresh: true
    });
  }

  /* Idler Timers */

  const lastRef = useRef(0);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (!isVerified || !idleMs || !idleWarnBeforeMs || idleMs < idleWarnBeforeMs) {
      return () => {
        clearInterval(interval);
      };
    }
    // const stepCount = out - notify;

    const resetLast = () => {
      if (lastRef.current === 0 || lastRef.current >= idleWarnBeforeMs) return;
      lastRef.current = 0;
    };
    interval = setInterval(() => {
      const newVal = lastRef.current + 10000;
      if (newVal >= idleMs) {
        setShowIdleWarning(false);
        setShowMaxlifeWarning(false);
        setIsMaxLifetimeExpired(false);
        refreshSessionChatbot({
          isRefresh: true
        });

        lastRef.current = 0;
      } else if (newVal >= idleWarnBeforeMs) {
        setShowIdleWarning(true);
        lastRef.current = newVal;
      } else {
        lastRef.current = newVal;
      }
    }, 10000);

    window.addEventListener('click', resetLast);
    window.addEventListener('mousemove', resetLast);
    window.addEventListener('keydown', resetLast);
    window.addEventListener('scroll', resetLast);

    return () => {
      clearInterval(interval);
      window.removeEventListener('click', resetLast);
      window.removeEventListener('mousemove', resetLast);
      window.removeEventListener('keydown', resetLast);
      window.removeEventListener('scroll', resetLast);
    };
  }, [isVerified, idleMs, idleWarnBeforeMs]);


  useLifetime(isVerified, sessionExpiredAt, sessionExpiredAt.time - lifetimeWarnBeforeMs,
    useCallback(() => {
      setShowMaxlifeWarning(true);
    }, []),
    useCallback(() => {
      setShowMaxlifeWarning(false);
      setIsMaxLifetimeExpired(false);
      setShowIdleWarning(false);
      refreshSessionChatbot({
        isRefresh: true
      });
    }, [])
  )

  useEffect(() => {
    if (infoChatbot.isError) {
      handleMaxLifeReset();
    }
  }, [infoChatbot.isError]);


  const showOverlay = useMemo(() => {
    return showIdleWarning || showMaxlifeWarning || isMaxLifetimeExpired
  }, [showIdleWarning, showMaxlifeWarning, isMaxLifetimeExpired]);

  return (
    <div
      style={infoChatbot?.bgType === 1 ? { "--chatbot-color": infoChatbot.mainColor } as React.CSSProperties : undefined}
      className={mapModifiers("t-chatting", chatbotEmbed ? "embed" : "")}
    >
      {infoChatbot?.bgType && infoChatbot?.bgType === 2 && <img src={infoChatbot.bgImage || noneBackgroundImg} alt={infoChatbot.bgImage} className="t-chattingNoInteraction_bg_image" />}

      <HeaderChatbot
        title={infoChatbot.name}
        subTitle={conversationTitle}
        isMinimize={isMinimize}
        noHistory={
          !codeConversation || roleRef.current === "guest" || role !== "staff"
        }
        isBackButton={modeHistory}
        handleBack={() => navigate(-1)}
        handleToggleMinimize={() => {
          setIsMinimize(!isMinimize);
          handleToggleExpand?.(!isMinimize);
        }}
        handleHistory={() => {
          setSearchParams({
            ...searchParams,
            mode: "history",
            code: codeConversation,
          });
        }}
        handleClose={handleCloseChatbot}
      />
      {modeHistory ? (
        <div className="t-chatting_body t-chatting_body-history">
          <ConversationHistory codeConversation={codeConversation} />
        </div>
      ) : (
        <>
          {infoChatbot?.bgType === 1 && <div
            className={mapModifiers(
              "t-chatting_bg",
              (codeConversation || conversations.length > 1) && "chat"
            )}
          >
            <span
              className="t-chatting_bg_left"
              style={
                { '--chatbot-bg-first-color': infoChatbot?.bgColorFirst } as React.CSSProperties
              }
            />
            <span
              className="t-chatting_bg_right"
              style={
                { '--chatbot-bg-second-color': infoChatbot?.bgColorSecond } as React.CSSProperties
              }
            />
            <span className="t-chatting_bg_top" />
          </div>}
          <div
            className="t-chatting_body"
            ref={chattingBoxRef}
            onScroll={(e) => handleScroll(e.currentTarget.scrollTop)}
          >
            {(isLoading || isFetchingNextPage) && (
              <div className="t-chatting_body_loading">
                <Loading />
              </div>
            )}

            {!codeConversation && !isCreateNewRef.current && (
              <div className="t-chatting_body_header">
                <div className="t-chatting_body_header_avatar">
                  <Image
                    imgSrc={infoChatbot?.avatar || userAvatar}
                    ratio={1}
                    alt="avatar"
                  />
                </div>
                <Typography.Heading type="h4" fontweight="600">
                  {infoChatbot?.shortDescription}
                </Typography.Heading>
              </div>
            )}
            <div className="t-chatting_body_conversation">
              {conversations &&
                conversations.length > 0 &&
                addDateHeaders(conversations, 'short')?.map((item, index) => {
                  return (
                    <>
                      {item.createAt && (
                        <Flex justify="center" align="center">
                          <div className="t-chatting_dateTime_wrap">
                            <Typography.Text extendClasses="fs-14x18 t-chatting_dateTime_text">
                              {item.createAt}
                            </Typography.Text>
                          </div>
                        </Flex>
                      )}
                      <div
                        className="t-chatting_body_conversationLine"
                        key={`conversation-line-${item.code || item.id
                          }_${index.toString()}`}
                      >
                        {item.question && (
                          <div className="t-chatting_body_conversationLine_item">
                            <ChatMessage
                              avatar={userAvatar}
                              content={item.question}
                              code={item.code}
                              isCopy={item.isCopy}
                              isRemove={item.isRemove}
                              files={item.files}
                              isRightSide
                              onDeleteQAndA={onHandleDeleteQAndA}
                              mainColor={infoChatbot?.mainColor}
                              conversationCode={codeConversation}
                              currentPlayingCode={currentPlayingCode}
                              setCurrentPlayingCode={setCurrentPlayingCode}
                              userSendAt={item.userSendAt}
                            />
                          </div>
                        )}
                        {item.answer && (
                          <div className="t-chatting_body_conversationLine_item">
                            <ChatMessage
                              avatar={infoChatbot?.avatar || userAvatar}
                              name={infoChatbot?.name}
                              content={item.answer}
                              question={item.question}
                              code={item.code}
                              actions={item.actions}
                              onChooseMessage={onChooseMessage}
                              onHandleRetryAnswer={onHandleRetryAnswer}
                              hasActions={item.hasActions}
                              conversationCode={codeConversation}
                              feedbackEmoji={item.feedbackEmoji}
                              failed={!!item.error}
                              files={item.files}
                              onUpdateActionForMessage={(code, em) => {
                                const inxItem = conversations.findIndex(
                                  (con) => con.code === code
                                );
                                const updateConversations = [...conversations];
                                updateConversations[inxItem].feedbackEmoji = em;
                                setConversations(updateConversations);
                              }}
                              knowledgeUsaged={item.knowledgeUsaged}
                              attachedMedia={item?.attachedMedia}
                              canRetry={item?.canRetry && !item?.aiActionId}
                              currentPlayingCode={currentPlayingCode}
                              setCurrentPlayingCode={setCurrentPlayingCode}
                              processMsgType={infoChatbot?.processMsgType}
                              processCustomMsg={infoChatbot?.processCustomMsg || "The system is processing, please wait a moment."}
                              exportChat={item?.exportChat}
                              timeResponse={item?.timeResponse}
                              timeSendAt={item?.timeSendAt}
                            />
                            {(item?.buttons && item?.buttons?.length > 0 && showActionButton && index === conversations.length - 1) && <div>

                              {item?.buttons?.map((button, index) => {
                                if (typeof button === 'string') {
                                  return (
                                    <ChatMessage
                                      isRightSide
                                      key={index.toString() + "button"}
                                      mainColor={infoChatbot?.mainColor}
                                      content={button}
                                      currentPlayingCode={currentPlayingCode}
                                      setCurrentPlayingCode={setCurrentPlayingCode}
                                      onSendSuggestMessage={() => {
                                        setShowActionButton(false)
                                        onSubmit({
                                          action: item?.action,
                                          code: item?.code,
                                          message: button,
                                        });
                                      }}
                                    />
                                  )
                                }
                                else if (typeof button === 'object') {
                                  return (
                                    <ChatMessage
                                      isRightSide
                                      key={index.toString() + "button"}
                                      mainColor={infoChatbot?.mainColor}
                                      content={button.name}
                                      currentPlayingCode={currentPlayingCode}
                                      setCurrentPlayingCode={setCurrentPlayingCode}
                                      onSendSuggestMessage={() => {
                                        setShowActionButton(false)
                                        onSubmit({
                                          action: button.action,
                                          code: item?.code,
                                          message: button?.name,
                                        });
                                      }}
                                    />
                                  )
                                }
                              })}
                            </div>}
                            {showSuggestion &&
                              infoChatbot.type === AGENT_TYPE.BOTH && (
                                <>
                                  <ChatMessage
                                    isRightSide
                                    mainColor={infoChatbot?.mainColor}
                                    content="Nhân viên công ty"

                                    onSendSuggestMessage={() =>
                                      onChooseMessage({
                                        id: "1",
                                        text: "Nhân viên công ty",
                                        type: "whoAreU",
                                        value: "staff",
                                      })
                                    }
                                  />
                                  <ChatMessage
                                    isRightSide
                                    mainColor={infoChatbot?.mainColor}
                                    content="Khách hàng"
                                    onSendSuggestMessage={() => {
                                      conversationAlreadyCreatedRef.current = true;
                                      onChooseMessage({
                                        id: "2",
                                        text: "Khách hàng",
                                        type: "whoAreU",
                                        value: "guest",
                                      });
                                    }}
                                  />
                                </>
                              )}
                            {showSuggestion &&
                              infoChatbot.type === AGENT_TYPE.VERIFIED && (
                                <ChatMessage
                                  isRightSide
                                  mainColor={infoChatbot?.mainColor}
                                  content="Xác thực ngay"
                                  onSendSuggestMessage={() =>
                                    onChooseMessage({
                                      id: "1",
                                      text: "Xác thực ngay",
                                      type: "whoAreU",
                                      value: "staff",
                                    })
                                  }
                                />
                              )}
                          </div>
                        )}
                      </div>
                    </>
                  )
                })}

              {(newQuestion.message ||
                (newQuestion.files && newQuestion.files?.length > 0)) && (
                  <div className="t-chatting_body_conversationLine">
                    <div className="t-chatting_body_conversationLine_item">
                      <ChatMessage
                        avatar={userAvatar}
                        content={newQuestion.message}
                        files={newQuestion.files}
                        isRightSide
                        code={newQuestion.code}
                        mainColor={infoChatbot?.mainColor}
                        conversationCode={codeConversation}
                        userSendAt={newQuestion.userSendAt?.toISOString()}
                      />
                    </div>
                    <div className="t-chatting_body_conversationLine_item">
                      <ChatMessage
                        content={displayAnwser.message}
                        question={newQuestion.message}
                        files={answer.files}
                        name={infoChatbot?.name}
                        isTyping={typing}
                        isSearchingData={searchingData}
                        currentPlayingCode={currentPlayingCode}
                        setCurrentPlayingCode={setCurrentPlayingCode}
                        onHandleRetryAnswer={onHandleRetryAnswer}
                        code={answer.code?.toString()}
                        mainColor={infoChatbot?.mainColor}
                        avatar={infoChatbot?.avatar || userAvatar}
                        conversationCode={codeConversation}
                        onUpdateActionForMessage={(code, em) => {
                          const inxItem = conversations.findIndex(
                            (item) => item.code === code
                          );
                          const updateConversations = [...conversations];
                          updateConversations[inxItem].feedbackEmoji = em;
                          setConversations(updateConversations);
                        }}
                        isPaused={isPaused}
                        knowledgeUsaged={answer.knowledgeUsaged}
                        processMsgType={infoChatbot?.processMsgType}
                        processCustomMsg={infoChatbot?.processCustomMsg || "The system is processing, please wait a moment."}
                      />
                    </div>

                  </div>
                )}

              {!codeConversation &&
                (mailVerify || phoneVerify) &&
                otpSendCounter >= 1 && (
                  <ChatMessage
                    isRightSide
                    mainColor={infoChatbot?.mainColor}
                    content="Gửi lại OTP"
                    onSendSuggestMessage={() =>
                      onChooseMessage({
                        id: uuidv1(),
                        text: "Gửi lại OTP",
                        type: "resendOtp",
                        value: "staff",
                      })
                    }
                  />
                )}
            </div>
          </div>
          <ChatBotFooter
            ref={textAreaRef}
            color={infoChatbot?.mainColor}
            method={method}
            onSubmit={(params) => {
              const uuid = uuidv1();
              dispatch(setCurrentUuid({ data: uuid }));
              const dataChat = {
                message: params.question,
                code: uuid,
                files: params.files,
                action: params.action,
              };
              onSubmit(dataChat);
            }}
            onSubmitPhone={(params) => {
              const uuid = uuidv1();
              setNewQuestion({
                message: params.question,
                code: uuid,
              });
              onSubmitPhone({ question: params.question });
            }}
            onSubmitMail={(params) => {
              const uuid = uuidv1();
              setNewQuestion({
                message: params.question,
                code: uuid,
              });
              onSubmitMail({ question: params.question });
            }}
            onSubmitVerifyOTP={(params) => {
              const uuid = uuidv1();
              setNewQuestion({
                message: params.question,
                code: uuid,
              });
              onSubmitVerifyOTP({ question: params.question });
            }}
            questionConfirmType={questionConfirmTypeRef.current}
            isProcessing={
              isLoadingSendOTPChatbot ||
              isLoadingSendMailOTPChatbot ||
              isLoadingverifyOTPChatbot ||
              isLoadingConversation ||
              searchingData ||
              typing ||
              otpSendCounter >= 3
            }
            // isProcessing={true}
            isOtpExceeded={otpSendCounter >= 3}
            conversationCode={codeConversation || ""}
            disabledUploadFiles={!codeConversation}
            onCloseStartVoice={() => {
              setIsShowWarning(true);
            }}
            onStopStreaming={() => {
              setSearchingData(false)
              setIsPaused(true);
              setTyping(false);
            }}
            suggestedMsg={infoChatbot.suggestedMsg}
            showSuggestionMsg={otpSendCounter >= 3 || conversations.length === 1}
            conversationLength={conversations.length}
            isVerified={isVerified}
            mainColor={infoChatbot?.mainColor}
            typeVerify={infoChatbot?.type}
          />

          <CustomModal
            isOpen={isShowWarning}
            cancelButton={{
              handleClick: () => {
                setIsShowWarning(false);
              },
              text: "Đã hiểu",
            }}
          >
            <Typography.Heading type="h5" textStyle="center">
              Đã ngừng ghi âm
            </Typography.Heading>
            <Typography.Text
              textStyle="center"
              extendClasses="t-chatting_modalWarning_description"
            >
              Tin nhắn thoại kèm văn bản chỉ có thể dài 1 phút
            </Typography.Text>
          </CustomModal>
        </>
      )
      }

      {
        showOverlay && (
          <div className="p-chatbotWidget_timeOut">
            <div className="p-chatbotWidget_timeOut_wrap">
              {/* 🔽 Priority: Session > Idle */}
              {isMaxLifetimeExpired ? (
                <Typography.Text extendClasses="p-chatbotWidget_timeOut_title f-20x24" />
              ) : showMaxlifeWarning ? (
                <>
                  <Typography.Text extendClasses="p-chatbotWidget_timeOut_title f-20x24">
                    {infoChatbot?.sessionData?.maxLifeWarningMessage || 'Your session will expire soon.'}
                  </Typography.Text>
                  <Button
                    onClick={() => { handleSessionContinue(); }}
                    className="p-chatbotWidget_timeOut_button"
                  >
                    {infoChatbot?.sessionData?.buttonTextWarningMessage || 'Continue'}
                  </Button>
                </>
              ) : showIdleWarning ? (
                <>
                  <Typography.Text extendClasses="p-chatbotWidget_timeOut_title f-20x24">
                    {infoChatbot?.sessionData?.idleTimeWarningMessage || 'You are idle. Continue?'}
                  </Typography.Text>
                  <Button
                    onClick={() => {
                      setShowIdleWarning(false);
                      lastRef.current = 0;
                      // scheduleIdleTimers();
                    }}
                    className="p-chatbotWidget_timeOut_button"
                  >
                    {infoChatbot?.sessionData?.buttonTextWarningMessage || 'Continue'}
                  </Button>
                </>
              ) : null}
            </div>
          </div>
        )
      }


    </div >
  );
};

export default Chatting;
